import GoogleMapsLoader from 'google-maps'

export default () => {
  return {
    init (el, options) {
      const site = document.head.querySelector('[name="site"]').content

      this.APIKEY = 'AIzaSyACKvX6H8cRHbyl-phw2Bm_DCBWRB0OgeE'

      this.$map = el

      if (site === 'kema') {
        this.lat = 56.2042682
        this.lng = 9.5686926
      } else if (site === 'jelt') {
        this.lat = 48.9103614
        this.lng = 2.2822221
      } else {
        this.lat = 53.771719
        this.lng = -1.414297
      }

      this.mapOptions = {
        center: {
          lat: this.lat,
          lng: this.lng
        },
        zoom: 11,
        disableDefaultUI: true,
        zoomControl: true
      }

      this.loadMap()
    },

    loadMap () {
      GoogleMapsLoader.KEY = this.APIKEY
      GoogleMapsLoader.load(google => {
        const styledMapType = new google.maps.StyledMapType([
          {
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5'
              }
            ]
          },
          {
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#616161'
              }
            ]
          },
          {
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#f5f5f5'
              }
            ]
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#bdbdbd'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#eeeeee'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#757575'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e5e5e5'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff'
              }
            ]
          },
          {
            featureType: 'road.arterial',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#757575'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
              {
                color: '#dadada'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#616161'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e'
              }
            ]
          },
          {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e5e5e5'
              }
            ]
          },
          {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [
              {
                color: '#eeeeee'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#c9c9c9'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#cad2d3'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e'
              }
            ]
          }
        ])

        this.map = new google.maps.Map(this.$map, this.mapOptions)
        this.google = google

        this.map.mapTypes.set('styled_map', styledMapType)
        this.map.setMapTypeId('styled_map')

        this.setupMarker()
      })
    },

    setupMarker () {
      let marker = new this.google.maps.Marker({
        position: {
          lat: this.lat,
          lng: this.lng
        },
        map: this.map,
        title: 'ROCOL'
      })

      marker.addListener('click', () => {
        console.log('Marker clicked')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core/map.js